import { css } from '@/styled-system/css';

export const listItemRecipe = css.raw({
  'paddingBlock': 'List.Item.padding.vert',
  'paddingInline': 'List.Item.padding.horz',
  '& li:first-child': {
    paddingBlockStart: 'List.Item.padding.first.top',
  },
  '& li:last-child': {
    paddingBlockEnd: 'List.Item.padding.last.bottom',
  },
});
